export const env = {
  version: '1.3.5',
};

export default env;
